import { useMemo } from 'react';
import { tiposDocumentoDe, type ContextoDocumento } from '@tanteo/compartido';
import { Campo, CampoLista, FilaCampos } from './base';

interface DocumentoTercero {
  tipo: string;
  numero: string;
}

/**
 * El par «tipo de documento + número» con el que se identifica a una persona o una organización.
 *
 * Los tipos válidos dependen del contexto (`tiposDocumentoDe`) y el NIT se escribe con su dígito de
 * verificación, así que la ayuda que lo dice vive aquí y no en cada formulario.
 */
export function CampoDocumento({
  contexto,
  valor,
  onCambio,
  etiquetaTipo = 'Tipo de documento',
  e2eTipo,
  e2eNumero,
}: {
  contexto: ContextoDocumento;
  valor: DocumentoTercero;
  onCambio: (valor: DocumentoTercero) => void;
  etiquetaTipo?: string;
  e2eTipo?: string;
  e2eNumero?: string;
}) {
  const tipos = useMemo(() => tiposDocumentoDe(contexto), [contexto]);
  const esOrganizacion = valor.tipo === '31';

  return (
    <FilaCampos>
      <CampoLista
        etiqueta={etiquetaTipo}
        value={valor.tipo}
        onChange={(e) => onCambio({ ...valor, tipo: e.target.value })}
        data-e2e={e2eTipo}
      >
        {tipos.map((t) => (
          <option key={t.codigo} value={t.codigo}>
            {t.nombre}
          </option>
        ))}
      </CampoLista>
      <Campo
        etiqueta="Número"
        inputMode={esOrganizacion ? 'text' : 'numeric'}
        value={valor.numero}
        ayuda={esOrganizacion ? 'Con el dígito de verificación: 900123456-8' : undefined}
        onChange={(e) => onCambio({ ...valor, numero: e.target.value.replace(/[^\dA-Za-z-]/g, '') })}
        data-e2e={e2eNumero}
      />
    </FilaCampos>
  );
}
